import type { JepxSettlement } from '@ebalance/proto/bffuser/v1/jepx_settlement_model_pb'
import { useTranslation } from 'react-i18next'

import { TertiaryButton } from '@enechain/ecloud-designsystem'
import { FaArrowDownToBracketRegular } from '@enechain/ecloud-icons'

import { iconSize } from '~/constants/iconSize'
import { useDownloadJepxSettlement } from '~/pages/JepxSettlement/hooks/useDownloadJepxSettlement'

type Props = {
  row: JepxSettlement
}

// 同じ操作列の「詳細」 (SettlementDetailButton) と文字の大きさ・余白を揃える。
const ROW_ACTION_BUTTON_PROPS = {
  fontSize: 'md',
  paddingX: 3,
  size: 'sm',
} as const

/**
 * 清算書 1 行の「PDF」「CSV」 (AC-JST-006・007)。 間接送電権・定額制の行にも出す。
 * 処理中の状態は行ごとに持つので、 押した行の同じ種類のボタンだけが disabled になる。
 */
export const SettlementRowActions = ({ row }: Props): React.ReactElement => {
  const { t } = useTranslation()
  const { pdf, csv } = useDownloadJepxSettlement(row)

  return (
    <>
      <TertiaryButton
        {...ROW_ACTION_BUTTON_PROPS}
        disabled={pdf.isPending}
        onClick={() => void pdf.download()}
      >
        <FaArrowDownToBracketRegular boxSize={iconSize.labeledButton} />
        {t('page:jepxSettlement.action.pdf')}
      </TertiaryButton>
      <TertiaryButton
        {...ROW_ACTION_BUTTON_PROPS}
        disabled={csv.isPending}
        onClick={() => void csv.download()}
      >
        <FaArrowDownToBracketRegular boxSize={iconSize.labeledButton} />
        {t('page:jepxSettlement.action.csv')}
      </TertiaryButton>
    </>
  )
}
